import React from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Col, DatePicker, Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {timeRangeOptionsStatistics} from "../../../../../constants/constants";
import {RangePickerContainer, SelectField, Wrapper} from "./TimeRangeFilter.styles";

export const TimeRangeFilter = ({
    dateType,
    selectFieldOnChange,
    rangePickerOnChange,
    isOrdersPage = false,
    showInfoTooltip = false,
    tooltipText = ""
}) => {
    const {RangePicker} = DatePicker;
    const {t} = useTranslation(["timeRangeOptionsStatistics"]);

    return useObserver(() => (
        <Wrapper isOrdersPage={isOrdersPage}>
            {rangePickerOnChange ? (
                <Col
                    {...(isOrdersPage
                        ? {xs: 24, sm: 24, md: 24, lg: 24, xl: 24, span: 24}
                        : {})}
                    style={{width: isOrdersPage ? "100%" : "auto", padding: 0}}
                >
                    {isOrdersPage && (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "6px"
                            }}
                        >
                            <h5 style={{whiteSpace: "nowrap", margin: 0}}>Tarih Aralığı</h5>
                            {showInfoTooltip && (
                                <Tooltip title={tooltipText}>
                                    <InfoCircleOutlined style={{color: "#000", fontSize: "12px"}} />
                                </Tooltip>
                            )}
                        </div>
                    )}
                    <SelectField
                        data-testid="timeRangeSelect"
                        value={dateType}
                        onChange={value => {
                            selectFieldOnChange(value);
                        }}
                    >
                        {timeRangeOptionsStatistics.map((obj, i) => (
                            <SelectField.Option
                                key={i}
                                data-testid="timeRangeSelect_option"
                                value={obj.value}
                            >
                                {t(obj.translation_key, {
                                    ns: "timeRangeOptionsStatistics"
                                })}
                            </SelectField.Option>
                        ))}
                    </SelectField>
                </Col>
            ) : null}
            {(isOrdersPage || dateType === "choose") && (
                <Col
                    {...(isOrdersPage
                        ? {xs: 24, sm: 24, md: 24, lg: 24, xl: 24}
                        : {})}
                    style={{width: isOrdersPage ? "100%" : "auto", padding: 0, marginTop: 5}}
                >
                    {dateType === "choose" && (
                        <RangePickerContainer>
                            <RangePicker
                                data-testid="timeRangePicker"
                                renderExtraFooter={() =>
                                    t("timeRangePickerPlaceholder", {ns: "common"})
                                }
                                placeholder={[
                                    t("fields.startDate", {ns: "common"}),
                                    t("fields.endDate", {ns: "common"})
                                ]}
                                onChange={(values, formatString, info) => {
                                    rangePickerOnChange(formatString);
                                }}
                            />
                        </RangePickerContainer>
                    )}
                </Col>
            )}
        </Wrapper>
    ));
};
